import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {map, take, tap} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Subscription} from 'rxjs';
import {Auth, authState, signInWithEmailAndPassword} from '@angular/fire/auth';
import {MatCard, MatCardContent, MatCardHeader, MatCardImage, MatCardTitle} from '@angular/material/card';
import {MatError, MatInput} from '@angular/material/input';
import {MatButton} from '@angular/material/button';
import {MatFormField} from '@angular/material/form-field';
import {NgOptimizedImage} from '@angular/common';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardImage,
        MatCardContent,
        MatFormField,
        ReactiveFormsModule,
        MatInput,
        MatError,
        MatButton,
        RouterLink,
        NgOptimizedImage
    ],
    standalone: true
})
export class LoginComponent implements OnInit, OnDestroy {

    loginForm: FormGroup;
    private authStateSubscription: Subscription;

    constructor(
        private router: Router,
        private formBuilder: FormBuilder,
        private fireAuth: Auth,
        private snackBar: MatSnackBar,
    ) {
        this.createForm();
    }

    ngOnInit(): void {
        this.authStateSubscription = authState(this.fireAuth).pipe(
            take(1),
            map(user => !!user),
            tap(loggedIn => {
                if (loggedIn) {
                    this.fireAuth.signOut().then(() => this.router.navigateByUrl('/login').then());
                }
            })
        ).subscribe();
    }

    createForm() {
        this.loginForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', Validators.required]
        });
    }

    tryLogin() {
        this.snackBar.dismiss();
        signInWithEmailAndPassword(this.fireAuth, this.loginForm.value.email, this.loginForm.value.password)
            .then(result => {
                result.user.reload().then(() => {
                    result.user.getIdTokenResult(true).then(token => {
                        if (token.claims.admin) {
                            this.router.navigate(['/']).then();
                        } else if (token.claims.operator) {
                            this.router.navigate(['/']).then();
                        } else {
                            this.fireAuth.signOut().then(() => this.router.navigateByUrl('/login').then());
                            this.snackBar.open('Account members with User level permissions do not have web platform access. ' +
                                'Please log into the SmartPart mobile app.', 'OK',
                                {verticalPosition: 'top', politeness: 'assertive', panelClass: ['snackbar-warn']});
                        }
                    });
                }, () => {
                    this.snackBar.open('Username or password is incorrect. Please try again.', 'OK',
                        {verticalPosition: 'top', politeness: 'assertive', panelClass: ['snackbar-warn']});
                });
            }).catch(() => {
            this.snackBar.open('Username or password is incorrect. Please try again.', 'OK',
                {verticalPosition: 'top', politeness: 'assertive', panelClass: ['snackbar-warn']});
        });
    }

    ngOnDestroy(): void {
        this.authStateSubscription.unsubscribe();
    }
}
